import { useTranslation } from 'react-i18next';
import { useStorage } from '../../hooks/use-storage';
import { useSwal } from '../../hooks/use-swal';
import { useAnalytics } from '../../utils/setup/analytics-setup';

function useSpotRejectedModal() {
  const storage = useStorage();
  const { t } = useTranslation();
  const { analyticsPageView } = useAnalytics();
  const { swal } = useSwal({ storage });

  function didOpen() {
    analyticsPageView('Spot Selection Quit');
  }

  async function show() {
    const result = await swal.fire({
      title: t('spot-rejected-modal.title'),
      text: t('spot-rejected-modal.text'),
      icon: 'error',
      showConfirmButton: false,
      showCancelButton: true,
      cancelButtonText: t('close'),
      didOpen,
    });

    return result;
  }

  return {
    showSpotRejectedModal: show,
  };
}

export { useSpotRejectedModal };
